/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ArtistRemixContestEndingSoonNotificationActionData
 */
export interface ArtistRemixContestEndingSoonNotificationActionData {
    /**
     * 
     * @type {string}
     * @memberof ArtistRemixContestEndingSoonNotificationActionData
     */
    entityUserId: string;
    /**
     * 
     * @type {string}
     * @memberof ArtistRemixContestEndingSoonNotificationActionData
     */
    entityId: string;
}

/**
 * Check if a given object implements the ArtistRemixContestEndingSoonNotificationActionData interface.
 */
export function instanceOfArtistRemixContestEndingSoonNotificationActionData(value: object): value is ArtistRemixContestEndingSoonNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "entityUserId" in value && value["entityUserId"] !== undefined;
    isInstance = isInstance && "entityId" in value && value["entityId"] !== undefined;

    return isInstance;
}

export function ArtistRemixContestEndingSoonNotificationActionDataFromJSON(json: any): ArtistRemixContestEndingSoonNotificationActionData {
    return ArtistRemixContestEndingSoonNotificationActionDataFromJSONTyped(json, false);
}

export function ArtistRemixContestEndingSoonNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtistRemixContestEndingSoonNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entityUserId': json['entity_user_id'],
        'entityId': json['entity_id'],
    };
}

export function ArtistRemixContestEndingSoonNotificationActionDataToJSON(value?: ArtistRemixContestEndingSoonNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_user_id': value.entityUserId,
        'entity_id': value.entityId,
    };
}

